import {
    MNO_LOADING,
    MNO_LOADED,
    MNO_DETAILS,
    MNO_EDITED,
    MNO_CREATED,
    MNO_DELETED,
    MNO_SEARCHED,
    MNO_FAILED,
    MNO_SUB_FORM,
    LOGOUT,
} from '../types';

import {
    createPaginated,
    editPaginated,
    deletePaginated,
} from '../../helpers/reduxUtils';

const initialState = {
    loading: false,
    allMnos: null,
    mno: null,
    subForm: null,
    searchResults: null,
    success: false,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case MNO_LOADING:
            return {
                ...state,
                loading: true,
                success: false,
            };
        case MNO_SUB_FORM:
            return {
                ...state,
                loading: false,
                subForm: action.payload,
            };
        case MNO_LOADED:
            return {
                ...state,
                loading: false,
                searchResults: null,
                allMnos: action.payload,
                mno: null,
                success: false,
            };
        case MNO_DETAILS:
            return {
                ...state,
                loading: false,
                mno: action.payload,
                success: false,
            };
        case MNO_EDITED:
            return {
                ...state,
                success: true,
                loading: false,
                allMnos: editPaginated(state.allMnos, action.payload),
            };
        case MNO_CREATED:
            return {
                ...state,
                success: true,
                loading: false,
                allMnos: createPaginated(state.allMnos, action.payload),
            };
        case MNO_DELETED:
            return {
                ...state,
                loading: false,
                allMnos: deletePaginated(state.allMnos, action.payload),
            };
        case MNO_SEARCHED:
            return {
                ...state,
                loading: false,
                searchResults: action.payload,
            };
        case MNO_FAILED:
            return {
                ...state,
                loading: false,
                success: false,
            };
        case LOGOUT:
            return {
                loading: false,
                allMnos: null,
                mno: null,
                searchResults: null,
                success: false,
            };
        default:
            return state;
    }
}